// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1pE-n","rootSuccess":"CompleteLink_rootSuccess__1vRJS","rootFailure":"CompleteLink_rootFailure__1qBRu","isDisabled":"CompleteLink_isDisabled__12vV-"};